import React, { useCallback } from "react";

import { faHashtag } from "@awesome.me/kit-4c83d50d0d/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import history from "~/lib/history";

import styles from "./TagComponent.module.css";

export const TagColorNames = ["NO_COLOR", "RED", "ORANGE", "YELLOW", "GREEN", "BLUE", "PURPLE"] as const;
export type TagColor = (typeof TagColorNames)[number];

export interface TagType {
	label: string;
	color: TagColor;
}

const TagComponent = ({ label, color, className }: TagType & { className?: string }) => {
	// copied from ~/lib/prose/nodes/tag.tsx
	const buildTagSearchUrl = useCallback((tagLabelWithHash: string) => {
		return `/search/?${new URLSearchParams({ q: `${tagLabelWithHash}` }).toString()}`;
	}, []);

	const goToTagSearch = useCallback(
		(tag: { label: string }) => {
			history.push(buildTagSearchUrl(`#${tag.label}`));
		},
		[buildTagSearchUrl],
	);

	const goToSearch = useCallback(
		(e: React.MouseEvent<HTMLDivElement>) => {
			if (e.defaultPrevented || e.altKey || e.shiftKey || e.ctrlKey || e.metaKey) return;
			e.preventDefault();
			goToTagSearch({ label: label });
		},
		[label, goToTagSearch],
	);
	return (
		<div
			style={{ color: `var(--tag-${color.toLowerCase()})` }}
			className={cx(className, styles.nowrap)}
			onClick={goToSearch}
		>
			<FontAwesomeIcon icon={faHashtag} className={styles.hashIcon} />
			<strong>{label}</strong>
		</div>
	);
};

export default TagComponent;
